// App-wide redux action types.

// Dispatched on Exit Journey to reset every slice to its initialState so a
// fresh journey re-fetches all details from the backend (no stale client cache).
export const APP_RESET = 'APP_RESET';
